import { createContext, type ReactNode } from 'react';
import { type Me } from '../api/me';
import { type DeployEnv } from '../config/env';

export interface Session {
  me: Me;
  tenantName: string;
  deployEnv: DeployEnv;
}

export const SessionContext = createContext<Session | null>(null);

export function SessionProvider({ value, children }: { value: Session; children: ReactNode }) {
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}
